import React, { Component } from "react";
import styled from "styled-components";
import { Consumer } from "../context/InfoContext";
import Row from "../dev/Row";
import Span from "../dev/Span";
import youtubeImage from "../assets/img/yt_icon_rgb.png";
import InfoProposal from "./InfoProposal";
import ArrowIcon from "../icon/ArrowIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import NotFavoriteIcon from "@material-ui/icons/StarBorderRounded";
import NotFavoriteIconHover from "@material-ui/icons/StarRounded";
import FavoriteIcon from "@material-ui/icons/StarRounded";
import FavoriteIconHover from "@material-ui/icons/StarHalfRounded";
import MoneyIcon from "@material-ui/icons/AttachMoney";
import StyleLink from '../dev/StyleLink';
const { REACT_APP_URI = "/" } = process.env;

class MainNav extends Component { 
    state={
    }
    getFavoriteChannels = () => {
        fetch(`${REACT_APP_URI}/FavoriteChannels/`, { credentials: "include" })
        .then(res => {
            if(res.ok) return res.json()
            else throw res;
        })
        .then(res => this.props.dispatch({ 
            type: 'setFavoriteChannels', 
            favoriteChannels: res.favoriteChannels,
        }))
    }
    toggleFavorite = (isFavorite) => {
        const { getFavoriteChannels } = this
        const { token } = this.props.user;
        const { infoId } = this.props.match.params
        fetch(`${REACT_APP_URI}/FavoriteChannels/`, {
            method: "post",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": token
            },
            body: JSON.stringify({ type: isFavorite ? "remove" : "add", infoId: infoId})
        })
        .then(res => {
            const { status } = res
            if (status === 200) getFavoriteChannels()
        })
    }
    renderFavorite = () => {
        const { toggleFavorite } = this
        const { infoId, messages, user:{ plan, auth }, favorite:{ favoriteChannels } } = this.props;
        if(!Array.isArray(favoriteChannels)) return
        const isFavorite = favoriteChannels.find(i => i.infoId === infoId) !== undefined
        return (
            <FavoriteWrap 
            id="user_tour_info_7"
                isFavorite={isFavorite} 
                onClick={() => {
                    auth === "notSignIn" 
                        ? this.props.dispatch({ type: "toggleUserField", condition: "signIn" })
                        : plan === "Free" || plan === "Creator" 
                            ? this.props.dispatch({ 
                                type: 'togglePaymentField', 
                                isPaymentGuideActive: true,
                                paymentGuideMinPlan: "Brand",})
                            :toggleFavorite(isFavorite)}}>
                <FavoriteIconWrap>
                    {isFavorite && <FavoriteIcon id="favoriteIcon"/>}
                    {isFavorite && <FavoriteIconHover id="favoriteIconHover"/>}
                    {!isFavorite && <NotFavoriteIcon id="notfavoriteIcon"/>}
                    {!isFavorite && <NotFavoriteIconHover id="notFavoriteIconHover"/>}
                </FavoriteIconWrap>
                <FavoriteContext isFavorite={isFavorite}>{messages.sidebar_favorite}</FavoriteContext>
                <FavoriteGuideWrap>
                    <FavoriteGuide>{messages.sidebar_unfavorite}</FavoriteGuide>
                </FavoriteGuideWrap>
            </FavoriteWrap>
        )
    }
    render() {
    const { infoId, messages } = this.props;
    const { plan, auth } = this.props.user;
    const { renderFavorite } = this
    return (
        <Consumer>
            {value => (
                <MainNavDefault>
                    <CreatorSearch>
                        <div>{messages.slide_search}</div>
                        <ArrowIcon />
                        <div>{value.title}</div>
                    </CreatorSearch>
                    <Row padding="24px 24px 0 24px" item='flex-start'>
                        <CreatorTitleImg CreatorTitleImgUrl={value.avatar} />
                        <Row
                            direction="column"
                            content="space-between"
                            width="auto"
                            padding="0 8px 3px 16px"
                        >
                            <ImgWrap>
                                <Span spanTitle size="1.2rem" color="#303030">
                                    {value.title}
                                </Span>
                            </ImgWrap>
                            <ImgWrap>
                                <a
                                    href={
                                        "https://www.youtube.com/channel/" +
                                        value.channelId
                                    }
                                    target="blank"
                                >
                                    <img src={youtubeImage} alt="youtube" />
                                </a>
                            </ImgWrap>
                        </Row>
                        {renderFavorite()}
                        <StyleLink to={`/Contact`} target={"_blank"}>
                            <RequestQouteButton>
                            <MoneyIcon id="favoriteIcon"/>
                                <RequestQouteContext>{messages.info_request_quote}</RequestQouteContext>    
                            </RequestQouteButton>
                        </StyleLink>
                        {value.title !== undefined && [
                        <InfoProposal
                            creatorTitle={value.title}
                            infoId={infoId}
                        />
                        ]}
                    </Row>
                </MainNavDefault>
            )}
        </Consumer>
    );
    }
}
const mapStateToProps = state => {
    return {
        messages: state.Messages,
        user: state.User,
        payment: state.Payment,
        favorite: state.FavoriteChannels,
    };
};
export default withRouter(connect(mapStateToProps)(MainNav));
//export default MainNav;

const MainNavDefault = styled.div`
    grid-area: mainnav;
    position: relative;
    display: flex;
    flex-direction: column;
`;
const CreatorSearch = styled.div`
    display: flex;
    align-items: center;
    padding: 24px 0 0 24px;
    color: #999999;
    font-size: 12px;
    font-weight: 300;
    div {
        margin-right: 14px;
    }
    div:nth-child(3) {
        margin-left: 14px;
        color: #666666;
        font-weight: 500;
        ${({ isBlur }) => isBlur ? 'filter: blur(5px)' : ''};
    }

`;
const ImgWrap = styled.div`
    display: flex;
    height: auto;
    align-items: center;
    img {
        margin: 0 0 0 5px;
        width: auto;
        height: 16px;
    }
`;
const CreatorTitleImg = styled.div`
    width: 60px;
    height: 60px;
    border-radius: 100%;
    background-image: url('${props => props.CreatorTitleImgUrl}');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 1rem;
`;
const Edit = styled.div`
    display: flex;
    justify-content: center;
    width: 128px;
    height: auto;
    padding: 0 8px;
    margin: 6px 8px 0 8px;
    color: #fff;
    font-size: 16px;
    background-color: #e94242;
    opacity: 0.8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
`;
const FavoriteGuideWrap = styled.div`
    position: absolute;
    display: flex;
    visibility: hidden;
    top: 50%;
    right: -10px;
    transform: translate(100%, -50%);
    transition: all .1s ease-in-out;
`
const FavoriteGuide = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    border-radius: 3px;
    background-color: #666;
    font-size: 16px;
    color: #fff;
    white-space: nowrap;
    &:after {
        position: absolute;
        content: '';
        display: flex;
        top: 50%;
        left: 1px;
        transform: translate(-50%, -50%) rotate(45deg);
        clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
        border-radius: 0 0 0 3px;
        width: 8px;
        height: 8px;
        background-color: #666;
        z-index: 10000;
    }
`
const FavoriteWrap = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    max-width: 120px;
    padding: 0 10px;
    border-radius: 5px;
    background-color: ${({isFavorite}) => isFavorite ? 'rgba(222,222,222,.4)' : 'rgba(222,6,6,.8)'};
    color: ${({isFavorite}) => isFavorite ? '#F9DB49' : '#fff'};
    #notFavoriteIconHover, #favoriteIconHover {
        display: none;
    }
    svg {
        font-size: 22px;
    }
    &:hover {
        background-color: ${({isFavorite}) => isFavorite ? 'rgba(222,222,222,.8)' : ''};
        #notFavoriteIconHover, #favoriteIconHover {
            display: initial;
        }
        #notfavoriteIcon, #favoriteIcon{
            display: none;
        }
        svg {
            font-size: 26px;
        }
        ${FavoriteGuideWrap}{
            visibility: ${({isFavorite}) => isFavorite ? 'visible' : ''};
        }
    }
    &:active {
        background-color: ${({isFavorite}) => isFavorite ? '#a0a0a0' : 'rgba(222,6,6,1)'};
    }
    transition: all .1s ease-in-out;
    cursor: pointer;
`
const FavoriteIconWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 26px;
`
const FavoriteContext = styled.div`
    display: flex;
    align-items: center;
    visibility: ${({isFavorite}) => isFavorite ? "hidden" : "visible"};
    max-width: ${({isFavorite}) => isFavorite ? "0" : "60px"};
    margin: ${({isFavorite}) => isFavorite ? "0" : "0 0 0 5px"};
    transition: max-width .3s ease-in-out;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
`
const RequestQouteButton = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    padding: 0 10px;
    margin-left:10px;
    border-radius: 5px;
    background-color: #e94242;
    cursor: pointer;
    color: #fff;
`

const RequestQouteContext = styled.div`
    padding-left: 5px;
    font-size: 16px;
    font-weight: 500;
`



// WEBPACK FOOTER //
// ./src/Info/MainNav.js